export const TYPES = {
    suppository:'suppository',
    troche: 'troche',
    capsule: 'capsule',
    treat: 'treat',
    solvent: 'solvent'
}

export default [
    {
        type:TYPES.suppository,
        name: "Fattyblend",
        factor:0.7,
        density:0.948 //g/ml
    },
    {
        type:TYPES.suppository,
        name: "PEGBlend",
        factor:0.8,
        density:1.13 //g/ml
    },
    {
        type:TYPES.suppository,
        name: "Supposibase-F",
        factor:0.7,
        density:0.94 //g/ml
    },
    {
        type:TYPES.suppository,
        name: "Supposiblend",
        factor:0.7,
        density:0.94 //g/ml
    },
    {
        type:TYPES.troche,
        name: "Troche Base SF with Bitter-Bloc",
        factor:0.8,
        density:1.13 //g/ml
    },
    {
        type:TYPES.troche,
        name: "Trochibase",
        factor:0.8,
        density:1.13 //g/ml
    },
    {
        type:TYPES.troche,
        name: "Trochibase S",
        factor:0.8,
        density:1.13 //g/ml
    },
    {
        type:TYPES.troche,
        name: "Trochibase S Flake",
        factor:0.8,
        density:1.13 //g/ml
    },
    {
        type:TYPES.treat,
        name:"Chew-Hesive",
        factor:0.9,
        density: 1.17 //g/ml
    },
    {
        type:TYPES.treat,
        name:"Gelatin Gummy",
        factor:0.9,
        density: 1.22 //g/ml
    },
    {
        type: TYPES.solvent,
        name: 'Purified Water',
        specificGravity: 1 //g/ml
    },
    {
        type: TYPES.solvent,
        name: 'Acetone',
        specificGravity: 0.79 //g/ml
    },
    {
        type: TYPES.solvent,
        name: 'Almond Oil',
        specificGravity: 0.92 //g/ml
    },
    {
        type: TYPES.solvent,
        name: 'Dimethyl Sulfoxide (DMSO)',
        specificGravity: 1.1 //g/ml
    },
    {
        type: TYPES.solvent,
        name: 'Ethyl Alcohol (Ethanol) 190 Proof',
        specificGravity: 0.816 //g/ml
    },
    {
        type: TYPES.solvent,
        name: 'Ethyl Alcohol (Ethanol) 200 Proof',
        specificGravity: 0.794 //g/ml
    },
    {
        type: TYPES.solvent,
        name: 'Ethoxy Diglycol',
        specificGravity: 0.991 //g/ml
    },
    {
        type: TYPES.solvent,
        name: 'Glycerin',
        specificGravity: 1.26 //g/ml
    },
    {
        type: TYPES.solvent,
        name: 'Isopropyl Alcohol 99%',
        specificGravity: 0.786 //g/ml
    },
    {
        type: TYPES.solvent,
        name: 'Isopropyl Alcohol 70%',
        specificGravity: 0.8775 //g/ml (average)
    },
    {
        type: TYPES.solvent,
        name: 'Isopropyl Myristate',
        specificGravity: 0.85 //g/ml (average)
    },
    {
        type: TYPES.solvent,
        name: 'Isopropyl Palmitate',
        specificGravity: 0.8525 //g/ml (average)
    },
    {
        type: TYPES.solvent,
        name: 'Mineral Oil (Heavy)',
        specificGravity: 0.875 //g/ml (average)
    },
    {
        type: TYPES.solvent,
        name: 'Mineral Oil (Light)',
        specificGravity: 0.849 //g/ml (average)
    },
    {
        type: TYPES.solvent,
        name: 'Propanediol',
        specificGravity: 1.053 //g/ml
    },
    {
        type: TYPES.solvent,
        name: 'Propylene Glycol',
        specificGravity: 1.036 //g/ml
    }
]